export default {
  copyright: '2020 gotin, All Rights Reserved',
  powerText: 'Powered by',

  //
  copyright1: '©️2020 gotin, All Rights Reserved',
  powered: 'Powered by gotin',
}
